import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

function StartFirebase() {
    const firebaseConfig = {
        apiKey: "AIzaSyA-4AxvH4J_EZEnLXe7fWNOzaedSycaPbE",
        authDomain: "fir-react-ce99b. firebaseapp.com",
        databaseURL: "https://hackdfw-e7bbd-default-rtdb.firebaseio.com/",
        projectId: "hackdfw-e7bbd",
        storageBucket: "fir-react-ce99b.appspot.com",
        messagingSenderId: "22817168162",
        appId: "1:22817168162:web: dc213cdad189aa048e2376"
    };

    const app = initializeApp(firebaseConfig);
    return getDatabase(app);
}

export default StartFirebase;